<script setup>
import { useSettingsStore } from '../stores/settings';
import Api from './Api.vue';
import Integration from './Integration.vue';

const { labels } = window.DATAGENT_PLUGIN_SETTINGS;

const settingsStore = useSettingsStore();

// Function to change active tab
const setActiveTab = (tab) => {
  settingsStore.setActiveSettingsTab(tab);
};

// Menus
const menus = [
  {
    id: 'api',
    label: labels.api,
    icon: 'fas fa-plug',
    component: Api,
  },
  {
    id: 'integrations',
    label: labels.integrations,
    icon: 'fas fa-puzzle-piece',
    component: Integration,
  },
];
</script>

<template>
  <div>
    <!-- Tab Navigation -->
    <div class="da:border-b da:border-gray-200">
      <nav class="da:flex da:space-x-2" aria-label="Tabs">
        <template v-for="menu in menus" :key="menu.id">
          <div
            @click="setActiveTab(menu.id)"
            :class="[
              settingsStore.activeSettingsTab === menu.id
                ? 'da:border-[#4CB21A] da:text-[#4CB21A]'
                : 'da:border-transparent da:text-gray-500 da:hover:text-gray-700 da:hover:border-gray-300',
              'da:cursor-pointer da:whitespace-nowrap da:py-4 da:px-6 da:border-b-3 da:font-medium da:text-sm da:focus:outline-none',
            ]"
            style=""
          >
            <i :class="menu.icon" class="da:mr-2"></i>
            <span>{{ menu.label }}</span>
          </div>
        </template>
      </nav>
    </div>

    <!-- Tab Content -->
    <div>
      <template v-for="menu in menus" :key="menu.id">
        <div v-show="settingsStore.activeSettingsTab === menu.id">
          <component :is="menu.component"></component>
        </div>
      </template>
    </div>
  </div>
</template>
